import { GoalType } from '@griply/types';
import { useCallback, useContext } from 'react';

import { CreateGoalOptions, GoalFormContext } from './goal-form-context';

// Projects reuse the goal form in project mode. Creation stays on the projects
// list (skipNavigation) instead of jumping to the new project's detail page.
export const useOpenCreateProjectDialog = () => {
  const { onCreateGoal } = useContext(GoalFormContext);

  return useCallback(
    (options?: CreateGoalOptions) =>
      onCreateGoal({
        skipNavigation: true,
        ...options,
        type: GoalType.Project,
      }),
    [onCreateGoal],
  );
};
